import * as d3 from 'd3'

export default {
  methods: {
    
    draw_Timeline() {    

      let timeline = this.canvasGantt
      .append('g')
      .attr('transform', `translate(${this.header.x + this.header.width}, ${this.header.y})`)

      timeline
      .append('rect') 
      .attr('x', -this.header.width).attr('y', 0).attr('width', this.header.length).attr('height', 3)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      timeline
      .append('rect')
      .attr('x', -this.header.width).attr('y', 3).attr('width', this.header.length).attr('height', this.header.height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      timeline
      .append('rect') 
      .attr('x', -this.header.width).attr('y', this.header.height + 1).attr('width', this.header.length).attr('height', 4)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      // Week Text & Timeline Seperator for the Week
      timeline
      .append('g')
      .selectAll('text')
      .data(this.timeline.week)
      .enter()
      .append('text')
      .attr('x', d => this.timeline.scale(d.mDate))
      .attr('y', 28 + 9*0.7)
      .style('font-size', 8.5)
      .attr('fill', '#757575')
      .attr('text-anchor', 'middle')
      .text(d => d.name)

      timeline
      .append('g')
      .selectAll('line')
      .data(this.timeline.week)
      .enter()
      .append('line')
      .attr('x1', d => this.timeline.scale(d.eDate)).attr('y1', 27)
      .attr('x2', d => this.timeline.scale(d.eDate)).attr('y2', 35)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5).attr('oapcity', .1)
      .attr('stroke-width', (d,i) => (i != this.timeline.week.length-1) ? 1 : 0)


      // Month Text & Timeline Seperator for the Month
      timeline
      .append('g')
      .selectAll('text')
      .data(this.timeline.month)
      .enter()
      .append('text')
      .attr('x', d => this.timeline.scale(d.mDate))
      .attr('y', 18 + 9*0.7)
      .style('font-size', 9).attr('fill', '#333').attr('text-anchor', 'middle')
      .text(d => d.name.toUpperCase())

      timeline
      .append('g')
      .selectAll('line')
      .data(this.timeline.month)
      .enter()
      .append('line')
      .attr('x1', d => this.timeline.scale(d.eDate)).attr('y1', 24)
      .attr('x2', d => this.timeline.scale(d.eDate)).attr('y2', 35)
      .attr('stroke', '#bcbcbc').attr('oapcity', .1)
      .attr('stroke-width', (d,i) => (i != this.timeline.month.length-1) ? 1 : 0)


      // Year Text & Timeline Seperator for the Year
      timeline
      .append('g')
      .selectAll('text')
      .data(this.timeline.year)
      .enter()
      .append('text')
      .attr('x', d => this.timeline.scale(d.mDate))
      .attr('y', 6 + 11*0.7)
      .style('font-size', 12).attr('fill', '#000').attr('text-anchor', 'middle')
      .text(d => d.name)

      timeline
      .append('g')
      .selectAll('path')
      .data(this.timeline.year)
      .enter()
      .append('path')
      .attr('d', (d, i) => {
        if (i != this.timeline.year.length-1) return `M${this.timeline.scale(d.eDate)}, ${2} V${19}`
      })
      .attr('stroke', '#bcbcbc').attr('oapcity', .1)
      .attr('stroke-width', 1)
    }, 
  }
}
